import React, { useState } from 'react';
import { Form, Formik } from 'formik';
import * as Yup from 'yup';
import { handlePauseSubscription } from '../../common/subscription/SubscriptionService';
import {
  Stack,
  Typography,
  CircularProgress,
  TextField,
  Box,
  Button,
} from '@mui/material';
import { showSuccessSnackbar } from '../../common/snackbar/SnackbarActions';
import CancelIcon from '@mui/icons-material/Cancel';
import SaveIcon from '@mui/icons-material/Save';

const validationSchema = Yup.object().shape({
  cycles: Yup.number()
    .typeError('Must be a number')
    .integer('Must be a whole number')
    .min(1, 'Must pause for at least 1 cycle')
    .max(3, 'A maximum 3 pause cycles are allowed')
    .required('Required'),
});

export default function PauseForm({ callback = () => {} }) {
  const [errorMessage, setErrorMessage] = useState('');

  return (
    <Formik
      initialValues={{
        cycles: null,
      }}
      validationSchema={validationSchema}
      onSubmit={async (values, { setSubmitting }) => {
        await handlePauseSubscription(values.cycles)
          .then(() => {
            showSuccessSnackbar(
              'Your subscription will be paused at the current period end date'
            );
            setSubmitting(false);
            callback();
          })
          .catch((err) => {
            console.error(err);
            setErrorMessage(err.message);
            setSubmitting(false);
          });
      }}
    >
      {({
        values,
        errors,
        touched,
        handleChange,
        handleBlur,
        isSubmitting,
      }) => {
        return (
          <Form>
            <Stack alignItems='center' justifyContent='center'>
              <Typography sx={{ textAlign: 'left' }}>
                To pause your subscription, please enter the number of pause
                cycles (1 to 3) below and Save. Your subscription will then be
                paused at the end of your current billing period for the number
                of cycles you select and then automatically resume. You can
                cancel this request later or manually resume a paused
                subcription at any time.
              </Typography>
              <TextField
                name='cycles'
                type='text'
                label='Number of Cycles to Pause'
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.cycles}
                placeholder='Number of Cycles to Pause'
                variant='standard'
                error={errors.cycles && touched.cycles}
                helperText={touched.cycles && errors.cycles}
                sx={{ m: 1, width: '20vw', minWidth: '35ch', maxLength: 1 }}
              />
              {errorMessage && (
                <Typography sx={{ color: 'error.main' }}>
                  {errorMessage}
                </Typography>
              )}
              <Box sx={{ m: 1, position: 'relative' }}>
                <Button
                  type={'submit'}
                  disabled={isSubmitting}
                  variant='contained'
                >
                  <SaveIcon style={{ marginRight: '5' }} />
                  Save
                </Button>
                {isSubmitting && (
                  <CircularProgress
                    size={24}
                    sx={{
                      color: 'secondary.main',
                      position: 'absolute',
                      top: '50%',
                      left: '50%',
                      marginTop: '-9px',
                      marginLeft: '-12px',
                    }}
                  />
                )}
              </Box>
              <Button
                type={'reset'}
                color='secondary'
                disabled={isSubmitting}
                variant='contained'
                onClick={callback}
              >
                <CancelIcon style={{ marginRight: '5' }} />
                Cancel
              </Button>
            </Stack>
          </Form>
        );
      }}
    </Formik>
  );
}
